import { createGlobalStyle, css } from "styled-components";
import "normalize.css";
import "system-font-css";

import HeeboBlack from "../../asserts/fonts/Heebo/static/Heebo-Black.ttf";
import HeeboRegular from "../../asserts/fonts/Heebo/static/Heebo-Regular.ttf";
import HeeboMedium from "../../asserts/fonts/Heebo/static/Heebo-Medium.ttf";
import HeeboSemiBold from "../../asserts/fonts/Heebo/static/Heebo-SemiBold.ttf";
import HeeboExtraBold from "../../asserts/fonts/Heebo/static/Heebo-ExtraBold.ttf";

const globalStyles = css`
  @font-face {
    font-family: Heebo;
    font-weight: 400; /*(regular)*/

    src: url(${HeeboRegular});
  }

  @font-face {
    font-family: Heebo;
    font-weight: 600; /*(Medium)*/

    src: url(${HeeboMedium});
  }

  @font-face {
    font-family: Heebo;
    font-weight: 700; /*(Bold)*/
    src: url(${HeeboSemiBold});
  }

  @font-face {
    font-family: Heebo;
    font-weight: 800; /*(Bold)*/
    src: url(${HeeboBlack});
  }
  @font-face {
    font-family: Heebo;
    font-weight: 900; /*(ExtraBold)*/
    src: url(${HeeboExtraBold});
  }

  html {
    box-sizing: border-box;
    font-size: calc(14px + 0.25vw);
    font-family: Heebo;
    width: 100vw;
    height: 100vh;
    min-height: 100vh;
    scrollbar-color: transparent;
    scrollbar-width: thin;
    padding: 0;
    margin: 0;
    overflow-y: hidden;
    overflow-x: hidden;
  }

  body {
    width: 100%;
    height: 100%;
    font-family: Heebo;
    min-height: 100vh;
    scrollbar-color: transparent;
    padding: 0;
    margin: 0;
    overflow-y: hidden;
    overflow-x: hidden;
  }

  /* WebKit and Chromiums */
  ::-webkit-scrollbar {
    background-color: transparent;
    border-radius: 5px;
    scrollbar-width: thin;
    width: 8px;
  }
  ::-webkit-scrollbar-thumb {
    background: transparent;
    border-radius: 5px;
    scrollbar-width: thin;
    width: 8px;
    height: 8px;
  }

  .MuiPickersDateRangePickerInput-root {
    align-items: center !important;
  }

  .MuiTypography-root {
    font-size: 16px;
    font-family: Heebo !important;
    margin-inline-start: 10px;
  }

  .MuiPopover-paper {
    max-height: 200px !important;
  }

  .MuiTabPanel-root {
    padding: 0 !important;
  }

  body[dir="rtl"] {
    direction: rtl;
    .MuiSelect-icon {
      right: auto;
    }
  }
  body[dir="ltr"] {
    direction: ltr;
    .MuiSelect-icon {
      left: auto;
    }
  }
  *,
  *:before,
  *:after {
    box-sizing: inherit;
    outline: none;
  }

  *:focus {
    outline: none;
  }

  textarea:focus,
  input:focus {
    outline: none;
  }

  a {
    text-decoration: none;
    color: #2460c3;
    &:hover {
      border-bottom: 1px solid #4373c3;
    }
  }

  .MuiInputBase-input-MuiOutlinedInput-input {
    line-height: 1em !important;
  }
  .input {
    line-height: 1em !important;
  }

  .modal {
    background-color: red;
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type="number"] {
    -moz-appearance: textfield;
  }

  .ql_xxx {
    color: #fff;
    border-radius: 25px;
    margin: 0 5px;
    padding: 5px 15px;
    background-color: #3b67ad;
    white-space: nowrap;
  }
`;

const GlobalStyles = createGlobalStyle`${globalStyles}`;
GlobalStyles.css = globalStyles;

export default GlobalStyles;
